import React, { ChangeEvent, useState, useEffect } from 'react';
import { InputMask } from '@react-input/mask';
import useValidateValue, { INVALID_CLASS } from '../../hooks/useValidateValue';
import { useAppContext } from '../../utils/ContextProviders/AppContext';
import { useFriendContext } from '../../utils/ContextProviders/FriendContext';
import styles from './AccountForm.module.scss';
import { convertMaskForInputMask, buildCountryOptions, usPhoneMask } from './utilities/accountFormUtilities';

function PhoneInput(props: {
  name: string;
  value: string;
  label: string;
  handleInput: (event: ChangeEvent<HTMLInputElement>) => void;
  handleCountrySelect?: (countryId: string) => void;
  errorMessage: string;
  fixedCountryMask?: string
}) {
  const {
    name,
    value,
    label,
    handleInput,
    handleCountrySelect,
    errorMessage,
    fixedCountryMask,
  } = props;

  const { countries } = useAppContext();
  const [mask, setMask] = useState(convertMaskForInputMask(usPhoneMask));
  const { friend } = useFriendContext();
  const { isPhoneNumberUnique } = friend;
  // eslint-disable-next-line prefer-const
  let { validationClass, validateValue } = useValidateValue();
  const [hasBeenValidated, setHasBeenValidated] = useState(false);

  if (!isPhoneNumberUnique) {
    validationClass = INVALID_CLASS;
  }

  function handleCountryChange(evt: ChangeEvent<HTMLSelectElement>) {
    setMask(convertMaskForInputMask(evt.target.selectedOptions[0].dataset.phoneMask));
    if (handleCountrySelect) {
      handleCountrySelect(evt.target.selectedOptions[0].value);
    }
  }

  useEffect(() => {
    if (fixedCountryMask) {
      setMask(convertMaskForInputMask(fixedCountryMask));
    }
  }, [fixedCountryMask]);

  return (
    <div>
      <label htmlFor={name} className={styles.label}>
        {label}
        <div>
          {!fixedCountryMask && (
            <select data-testid="select" className={styles.phoneInputSelect} onChange={handleCountryChange}>
              {buildCountryOptions(countries)}
            </select>
          )}
          <InputMask
            mask={mask}
            inputMode="tel"
            className={`${styles.phoneInput} ${validationClass}`}
            name={name}
            value={value}
            maxLength={17}
            onChange={(evt: React.ChangeEvent<HTMLInputElement>) => {
              handleInput(evt);
              if (hasBeenValidated) {
                validateValue(name, evt.target.value);
              }
            }}
            onBlur={(evt: React.ChangeEvent<HTMLInputElement>) => {
              if (!hasBeenValidated) {
                setHasBeenValidated(true);
                validateValue(name, evt.target.value.trim());
              }
            }}
          />
          {validationClass === INVALID_CLASS
            ? <p className={styles.inputError}>{!friend.isPhoneNumberUnique ? 'This mobile number is already in use.' : errorMessage}</p>
            : <p className={styles.inputError}> </p>}
        </div>
      </label>
    </div>
  );
}

PhoneInput.defaultProps = {
  fixedCountryMask: '',
  handleCountrySelect: () => {},
};

export default PhoneInput;
